import { render } from "./CampaignBudgetBlock.vue?vue&type=template&id=a1534f52"
import script from "./CampaignBudgetBlock.vue?vue&type=script&lang=js"
export * from "./CampaignBudgetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/CampaignBudgetBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1534f52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1534f52', __exports__)) {
    api.reload('a1534f52', __exports__)
  }
  
  module.hot.accept("./CampaignBudgetBlock.vue?vue&type=template&id=a1534f52", () => {
    api.rerender('a1534f52', render)
  })

}


export default __exports__